var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_11838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 14.72C18 15.136 17.8518 15.4533 17.5553 15.672C17.2588 15.8907 16.8949 16 16.4636 16H1.53639C1.10512 16 0.74124 15.888 0.444744 15.664C0.148248 15.44 0 15.1253 0 14.72C0 14.4 0.097035 14.0747 0.291105 13.744L7.74663 0.88C8.10243 0.293333 8.52291 0 9.00809 0C9.49326 0 9.90296 0.293333 10.2372 0.88L17.7089 13.76C17.903 14.1013 18 14.4213 18 14.72ZM10.124 6.544V4.208H7.87601V6.544C7.87601 6.69333 7.88679 6.83467 7.90836 6.968C7.92992 7.10133 7.95957 7.25067 7.9973 7.416C8.03504 7.58133 8.06469 7.72267 8.08625 7.84L8.50674 10.432H9.46092L9.89757 7.84C9.91914 7.73333 9.95148 7.59467 9.99461 7.424C10.0377 7.25333 10.0701 7.10133 10.0916 6.968C10.1132 6.83467 10.124 6.69333 10.124 6.544ZM10.124 12.736C10.124 12.4267 10.0135 12.1653 9.79245 11.952C9.57143 11.7387 9.30458 11.632 8.99191 11.632C8.69003 11.632 8.42857 11.7387 8.20755 11.952C7.98652 12.1653 7.87601 12.4267 7.87601 12.736C7.87601 13.0453 7.98652 13.3093 8.20755 13.528C8.42857 13.7467 8.69003 13.856 8.99191 13.856C9.30458 13.856 9.57143 13.7467 9.79245 13.528C10.0135 13.3093 10.124 13.0453 10.124 12.736Z",
    fill: "#FF9500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_11838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.74598f4666c0c802ead6d8d9860d3d49.svg";
export { ForwardRef as ReactComponent };